<template>
  <component :is="chartType" :chartData="chartData" />
</template>

<script>
import PriceChange from "./PriceChange";
import TvlChange from "./TvlChange";

export default {
  components: {
    price: PriceChange,
    aum: TvlChange,
  },
  props: ["chartType", "chartData"],
};
</script>
